import axios from 'axios';
import Storage from 'helpers/storage';
import { toast } from 'react-toastify';
import swal from '../helpers/swal';

const api = axios.create({ baseURL: process.env.REACT_APP_URL_API });
const apiElite = axios.create({ baseURL: process.env.REACT_APP_URL_API });
const masterAgentApi = axios.create({ baseURL: process.env.REACT_APP_URL_API });

api.interceptors.request.use(config => {
  if (Storage.get("token"))
    config.headers.Authorization = `Bearer ${Storage.get("token")}`;

  return config;
});

api.interceptors.response.use(async ok => {
  if (ok.data.status == 'false' && ok.data.message == 'user already logged in') {
    let a = await swal.user();
    if (a.isDismissed) {
      return {
        data: {
          message: "cancel",
          status: "false"
        }
      };
    } else if (a.isConfirmed) {
      return await api.post('login', { ...ok.data.credentials, to_force: true });
    }
  }
  return ok;
}, async error => {

  let isLogged = (
    Storage.get("token")
  );

  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if(error.response){
    if (error.response.status === 500) {
      await swal.error(error.response.data.message);
    }
    else if (error.response.status === 403) {
      //let response = error.response;
      //swal.error(response.data.message);
    }
    else if (error.response.status === 404) {
    }
    else if (error.response.status === 401) {
      //if (error.response.status === 401 && error.response.data.message == 'Unauthenticated.') {
      if (error.response.data.message == 'Unauthenticated.') {
        if (!Storage.get("expired")) {
          Storage.setTemp("expired", '1')
          await swal.session_expired();
          if (window.location.href.indexOf('login') == -1) {
            window.location.href = '\login';
          }
        }
      } /*else {
        //localStorage.clear();
        if (window.location.href.indexOf('login') == -1) {
          window.location.href = '\login';
        }
      }*/
      // return history.push("login");
    } else if (error.response.status === 422) {
      const { data } = error.response
      data.message.forEach(m => toast.error(m, { 
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        closeOnClick: true
      }))
    }
  }

  return Promise.reject(error);
});

export { api, apiElite, masterAgentApi };